<template>
  <div>
    <b-row>


    </b-row>
      <b-row>
      <b-form-group
          id="input-module-id"
          :label="$t('parametrics.moduleId')"
          label-for="input-id"
          label-align="left"
          class="col-lg-1 col-md-2"
      >
        <b-form-input
            id="input-id"
            type="text"
            v-model="module.id"
            disabled
            placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-module-status"
        :label="$t('parametrics.moduleStatus')"
        label-for="module-status"
        label-align="left"
        class="col-lg-2 col-md-3"
      >
        <b-select
          id="module-status"
          v-model="module.active" 
          :options="moduleStatuses">
          >
        </b-select>
      </b-form-group>
      <b-form-group
        id="input-module-degree"
        :label="$t('parametrics.moduleDegree')"
        label-for="module-degree"
        label-align="left"
        class="col-2"
      >
        <b-select
          id="module-degree"
          v-model="module.degree" 
          :options="moduleDegrees">
          >
        </b-select>
      </b-form-group>
      <b-form-group
          id="input-module-participants-limit"
          :label="$t('parametrics.moduleParticipantsLimit')"
          label-for="input-participants-limit"
          label-align="left"
          class="col-2"
      >
        <b-form-input
            id="input-priority"
            type="number"
            v-model="module.participantLimit"
            placeholder=""
            v-b-popover.hover.top="$t('parametrics.moduleParticipantsLimitInfo')"
        ></b-form-input>
      </b-form-group>
      <b-form-group
          id="input-module-requires-plan"
          :label="$t('parametrics.moduleRequiresPlan')"
          label-for="input-requires-plan"
          label-align="left"
          class="col-2"
      >
        <b-form-checkbox
            id="input-requires-plan"
            v-model="module.requiresPlan"
            placeholder=""
            v-b-popover.hover.top="$t('parametrics.moduleRequiresPlanInfo')"
        ></b-form-checkbox>
      </b-form-group>
      <!-- <b-form-group
          id="input-module-priority"
          :label="$t('parametrics.modulePriority')"
          label-for="input-priority"
          label-align="left"
          class="col-2"
      >
        <b-form-input
            id="input-priority"
            type="text"
            v-model="module.priority"
            placeholder=""
        ></b-form-input>
      </b-form-group> -->
    </b-row>
    <hr />
    <b-row>
      <b-form-group
          id="input-module-title"
          :label="$t('parametrics.moduleTitle')"
          label-for="input-title"
          label-align="left"
          class="col"
      >
        <b-form-input
            id="input-title"
            type="text"
            v-model="module.title"
            placeholder=""
        ></b-form-input>
      </b-form-group>
    </b-row>
    <b-row>
      <b-form-group
        id="input-module-branch"
        :label="$t('parametrics.moduleBranch')"
        label-for="module-branch"
        label-align="left"
        class="col-3"
      >
        <b-select
          id="module-branch"
          v-model="module.branch" 
          :options="moduleBranches">
          >
        </b-select>
      </b-form-group>
      <b-form-group
        v-if="moduleBillMethods"
        id="input-module-billmethod"
        :label="$t('parametrics.moduleBillMethod')"
        label-for="module-billmethod"
        label-align="left"
        class="col-3"
      >
        <v-select
          id="module-billmethod"
          :options="moduleBillMethods"
          placeholder=""
          :clearable='false'
          label="name"
          v-model="module.billMethod"
          class="bg-white rounded"
        >
          <template #no-options="{ }">
            {{ $t("parametrics.noBillMethods") }}
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
        id="input-module-applyMethod"
        :label="$t('parametrics.moduleApplyMethod')"
        label-for="module-applyMethod"
        label-align="left"
        class="col-3"
      >
        <b-select
          id="module-applyMethod"
          v-model="module.applyMethod" 
          :options="moduleApplyMethods">
          >
        </b-select>
      </b-form-group>
      <b-form-group
        id="input-module-unitTypeResponsible"
        :label="$t('parametrics.moduleUnitTypeResponsible')"
        label-for="module-unitTypeResponsible"
        label-align="left"
        class="col-3"
      >
        <b-select
          id="module-unitTypeResponsible"
          v-model="module.unitTypeResponsible" 
          :options="moduleunitTypeResponsibles">
          >
        </b-select>
      </b-form-group>


    </b-row>
      
    <b-row>
      <b-form-group
          id="input-module-color"
          :label="$t('parametrics.color')"
          label-align="left"
          label-for="module-color"
          class="col-2"
      >
        <b-form-input  id="module-color" type="color" v-model="module.color"/>
      </b-form-group>

      <b-form-group
          id="input-module-weight"
          :label="$t('parametrics.weight')"
          label-for="module-weight"
          class="col-2"
          label-align="left"
      >
        <b-form-input  id="module-weight" type="number" v-model="module.weight"> </b-form-input>
      </b-form-group>

    </b-row>
    <hr />
    <b-row v-if="availableModules">
      <b-form-group
        id="input-module-required-module-add"
        :label="$t('parametrics.moduleRequiredModuleAdd')"
        label-for="module-required-module-add"
        label-align="left"
        class="col-8"
      >
        <v-select
          id="module-required-module-add"
          :options="availableModules"
          placeholder=""
          :clearable='false'
          label="title"
          v-model="reqModuleToAdd.prerequisiteModule"
          class="bg-white rounded"
        >
          <template #no-options="{ }">
            {{ $t("parametrics.noRequiredModulesToAdd") }}
          </template>
        </v-select>
      </b-form-group>
      <b-button class="esep-blue-bg ml-auto my-auto mr-3" variant="primary" @click="addReqModule" :disabled="!reqModuleToAdd.prerequisiteModule">
        {{ $t("common.add") }}
      </b-button>
    </b-row>
    <b-table 
      :items="dependencies"
      :fields="reqModuleFields"
      :sort-by.sync="reqModuleSortBy"
      :sort-desc.sync="reqModuleSortDesc"
      :per-page="reqModulePerPage"
      :current-page="reqModuleCurrentPage"
      responsive
      show-empty
      ref="requiredModulesTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >      

      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="deleteReqModule(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('parametrics.deleteReqModule')"
        >
          <b-icon icon="trash" ></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("parametrics.emptyReqModulesTable") }}</h6>
      </template>

    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="reqModuleCurrentPage"
          :total-rows="reqModuleRows"
          :per-page="reqModulePerPage"
          align="right"
          aria-controls="req-modules-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
    <hr />
    <b-row >
      <b-form-group
        v-if="availableTitles"
        id="input-module-title-add"
        :label="$t('parametrics.moduleTitleToAdd')"
        label-for="module-title-add"
        label-align="left"
        class="col-8"
      >
        <v-select
          id="module-title-add"
          :options="availableTitles"
          placeholder=""
          :clearable='false'
          label="name"
          v-model="titleToAdd"
          class="bg-white rounded"
        >
          <template #no-options="{ }">
            {{ $t("parametrics.noTitlesToAdd") }}
          </template>
        </v-select>
      </b-form-group>
      <b-button class="esep-blue-bg ml-auto my-auto mr-3" variant="primary" @click="addTitle" :disabled="!titleToAdd">
        {{ $t("common.add") }}
      </b-button>
    </b-row>
    <b-table 
      :items="moduleTitles"
      :fields="titleFields"
      :sort-by.sync="titleSortBy"
      :sort-desc.sync="titleSortDesc"
      :per-page="titlePerPage"
      :current-page="titleCurrentPage"
      responsive
      show-empty
      ref="titlesTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >      

      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="deleteTitle(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('parametrics.deleteTitle')"
        >
          <b-icon icon="trash" ></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("parametrics.emptyTitlesTable") }}</h6>
      </template>

    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="titleCurrentPage"
          :total-rows="titleRows"
          :per-page="titlePerPage"
          align="right"
          aria-controls="titles-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
    <hr />
    <b-button @click="saveModule" variant="success" class="float-left" v-if="$route.name== 'moduleEdit'">{{
        $t("common.save")
      }}
    </b-button>
    <b-button @click="createModule" variant="success" class="float-left" :disabled='emptyFields' v-else>{{
        $t("common.submit")
      }}
    </b-button>
  </div>
</template>

<script>
import trainingService from '../../services/training.service';
import {handleApiError} from "../../services/error.service";

export default {
  computed: {
    moduleTitles() {
      let moduleTitles = [];
      this.module.titles.forEach(title => {
        let moduleTitle = {name: this.$t(`licensesEnums.${title}`), id: title};
        moduleTitles.push(moduleTitle);
      });
      return moduleTitles;
    },
    reqModuleRows() {
      return this.dependencies? this.dependencies.length : 0;
    },
    titleRows() {
      return this.module.titles? this.module.titles.length : 0;
    },
    emptyFields() {
      let module = this.module;
      return !module.billMethod || !module.title
    }
  },
  props: {
    module: Object,
    dependencies: Array
  },
  mounted() {
    this.$log.debug('current module')
    this.$log.debug(this.module);
    this.getBillingMethods();
    this.getAllModules();
    this.getAllTitles();
  },
  data() {
    return {
      moduleTypes: [
        { value: 'OLD_MODULE', text: this.$t('moduleTypeEnums.OLD_MODULE') },
        { value: 'FLEX_MODULE', text: this.$t('moduleTypeEnums.FLEX_MODULE') }
      ],
      moduleStatuses: [
        { value: true, text: this.$t('moduleStatusEnums.true') },
        { value: false, text: this.$t('moduleStatusEnums.false') }
      ],
      moduleDegrees: [
        { value: true, text: this.$t('moduleDegreeEnums.true') },
        { value: false, text: this.$t('moduleDegreeEnums.false') }
      ],
      moduleBranches: [
        { value: "COMMON", text: this.$t('branchTypeEnums.COMMON') },
        { value: "CUBS", text: this.$t('branchTypeEnums.CUBS') },
        { value: "SCOUTS", text: this.$t('branchTypeEnums.SCOUTS') },
        { value: "VENTURES", text: this.$t('branchTypeEnums.VENTURES') },
        { value: "ROVERS", text: this.$t('branchTypeEnums.ROVERS') },
        { value: "LEADERSHIP", text: this.$t('branchTypeEnums.LEADERSHIP') },
        { value: "TRAINERS", text: this.$t('branchTypeEnums.TRAINERS') },
        { value: "AIRSCOUTS", text: this.$t('branchTypeEnums.AIRSCOUTS') },
        { value: "SEASCOUTS", text: this.$t('branchTypeEnums.SEASCOUTS') },
        { value: "SPECIAL", text: this.$t('branchTypeEnums.SPECIAL') },
        { value: "SEMINARS", text: this.$t('branchTypeEnums.SEMINARS') }
      ],
      moduleBillMethods: null,
      moduleApplyMethods: [
        { value: "NONE", text: this.$t('applyMethodEnums.NONE') },
        { value: "TRAINER", text: this.$t('applyMethodEnums.TRAINER') },
        { value: "TEXT_WRITING", text: this.$t('applyMethodEnums.TEXT_WRITING') },
        { value: "SEND_MATERIAL", text: this.$t('applyMethodEnums.SEND_MATERIAL') },
        { value: "IN_TRAINING", text: this.$t('applyMethodEnums.IN_TRAINING') }
      ],
      moduleunitTypeResponsibles: [
        { value: 'CITY_DISTRICT', text: this.$t('moduleUnitTypeResponsibleEnums.CITY_DISTRICT') },
        { value: 'GENERAL_DISTRICT', text: this.$t('moduleUnitTypeResponsibleEnums.GENERAL_DISTRICT') }
      ],
      titleToAdd: null,
      availableTitles: null,
      titleFields: [
        { key: "name", label: "Τίτλος Εντολής", sortable: true, class: 'text-left', thClass: 'text-center'},
        { key: "action", label: "Ενέργεια", sortable: false, class: 'action-width' }
      ],
      titleSortBy: "name",
      titleSortDesc: false,
      titlePerPage: 10,
      titleCurrentPage: 1,
      reqModuleToAdd: {
        module: this.module,
        prerequisiteModule: null
      },
      availableModules: null,
      reqModuleFields: [
        { key: "prerequisiteModule.title", label: "Προαπαιτούμενη Ενότητα", sortable: true, class: 'text-left', thClass: 'text-center'},
        { key: "action", label: "Ενέργεια", sortable: false, class: 'action-width' }
      ],
      reqModuleSortBy: "name",
      reqModuleSortDesc: false,
      reqModulePerPage: 10,
      reqModuleCurrentPage: 1,
    }
  },
  methods: {
    getBillingMethods() {
      trainingService.getBillingMethods().then(
        (response) => {
          this.$log.debug("billingMethods")
          this.$log.debug(response.data);
          this.moduleBillMethods = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getAllModules() {
      trainingService.getModulesByCriteria(true).then(
        (response) => {
          this.$log.debug("modules")
          this.$log.debug(response.data);
          this.availableModules = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getAllTitles() {
      trainingService.getAllLicenses().then(
        (response) => {
          this.$log.debug(response.data)
          this.availableTitles = response.data.map(title => {
            const translatedTitle = {};

            translatedTitle.name = this.$t(`licensesEnums.${title}`);
            translatedTitle.id = title;

            return translatedTitle;
          });
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    addReqModule() {
      this.$log.debug(this.reqModuleToAdd);
      let reqModuleExists = false;
      if(this.dependencies?.length > 0) {
        this.dependencies.forEach(reqModule =>
          {
            if(reqModule.id == this.reqModuleToAdd.id) {
              reqModuleExists = true;
            }
          }
        )
        if(!reqModuleExists) {
          this.dependencies.push(this.reqModuleToAdd);
          this.$log.debug(this.dependencies)
        }
      } else {
        this.dependencies = [];
        this.dependencies.push(this.reqModuleToAdd);
      }
      this.reqModuleToAdd = {
        module: this.module,
        prerequisiteModule: null
      };
    },
    deleteReqModule(row) {
      this.$log.debug(row);
      for (let i = 0; i < this.dependencies.length; i++) {
        if (row.index == i) {
          this.dependencies.splice(i, 1);
        }
      }
    },
    addTitle() {
      this.$log.debug(this.titleToAdd);
      let titleExists = false;
      this.module.titles.forEach(title =>
        {
          if(title == this.titleToAdd.id) {
            titleExists = true;
          }
        }
      )
      if(!titleExists) {
        this.module.titles.push(this.titleToAdd.id);
      }
      this.titleToAdd = null;
    },
    deleteTitle(row) {
      this.$log.debug(row);
      for (let i = 0; i < this.module.titles.length; i++) {
        if (row.index == i) {
          this.module.titles.splice(i, 1);
        }
      }
    },
    saveModule() {
      let reqModules = []
      this.dependencies.forEach(reqModule => {
        reqModules.push(reqModule.prerequisiteModule);
      })
      this.module.prerequisiteModules = reqModules;
      this.$log.debug(this.module)
      trainingService.updateModule(this.module).then(
        () => {
          this.$emit('emit-success', this.$t('parametrics.moduleSaved'));
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    createModule() {
      let reqModules = []
      if(this.dependencies) {
        this.dependencies.forEach(reqModule => {
          reqModules.push(reqModule.prerequisiteModule);
        })
      }      
      this.module.prerequisiteModules = reqModules;
      this.$log.debug(this.module);
      trainingService.createModule(this.module).then(
        (response) => {
          this.$log.debug(response.data);
          this.$store.state.moduleJustCreated = true;
          this.$router.push({name: 'moduleEdit', params: {id: response.data.id}});
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>

<style>
.action-width {
  width: 13rem;
  max-width: 13rem;
  min-width: 13rem;
}

/* -- Hiding arrows from number input types -- */
/* Chrome, Safari, Edge, Opera */
/* input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox 
input[type=number] {
  -moz-appearance: textfield;
} */

</style>
